<template>
  <router-link :to="to" class="btn btn-red" :class="{ 'btn-primary': primary, 'btn-full-width': fullWidth }">
    <slot />
  </router-link>
</template>

<script>
  export default {
    props: {
      to: {
        type: Object,
        required: true,
      },
      primary: {
        type: Boolean,
        default: false,
      },
      fullWidth: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../variables';

  .btn {
    border-radius: 0;
    padding: 1rem;
    display: inline-block;
    &.btn-full-width {
      width: 100%;
      display: block;
    }
    &.btn-red {
      background: $brand;
      color: $white;
      border: 1px solid $brand;
      &:hover {
        color: $brand;
        background: $white;
      }
    }
    &.btn-link {
      padding: .15rem .5rem;
      position: relative;
      color: $text-color;
      font-weight: 500;
      &:before {
        content: '';
        width: 50px;
        height: 30px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        background: $rosybrown;
        border-radius: 5px;
      }
    }
  }

  .btn-primary {
    background: $brand;
    color: $white;
    &:hover {
      background: $white;
      color:  $brand;
    }
  }
</style>
